//@ 拼湊錯誤訊息
interface ErrorDetail {
  message: string;
  type?: string;
}
type ErrorList = Record<string, ErrorDetail>;

export const combinedErrorMessage = (errorList: ErrorList): string => {
  return Object.values(errorList)
    .map((error) => error.message)
    .filter(Boolean)
    .join(", ");
};

export const getFirstText = (text: string): string => {
  return text ? text[0] : "";
};

//@ 字數截短
export const textTruncate = (text: string, maxLen: number = 10, suffix: string = "..."): string => {
  if (text.length <= maxLen) return text;
  return text.slice(0, maxLen) + suffix;
};
